import React from 'react';
import { InstantSearch, Hits } from 'react-instantsearch/dom';
import { Panel, Box } from 'src/components/matchbox';
import AlgoliaResults from './AlgoliaResults';
import AlgoliaSearch from './AlgoliaSearch';
import config from 'src/appConfig';
import styles from './SearchPanel.module.scss';

const searchCfg = config.support.algolia;

const SearchPanel = ({ defaultSearchText }) => (
  <InstantSearch appId={searchCfg.appID} apiKey={searchCfg.apiKey} indexName={searchCfg.index}>
    <Panel.LEGACY.Section>
      <AlgoliaSearch defaultSearchText={defaultSearchText} />
    </Panel.LEGACY.Section>
    <Panel.LEGACY.Section>
      <div className={styles.Results}>
        <Box height="1100" overflowY="scroll">
          <Hits hitComponent={AlgoliaResults} />
        </Box>
      </div>
    </Panel.LEGACY.Section>
  </InstantSearch>
);

export default SearchPanel;
